import namespace from '../../config/Namespace';

const types = {
  actions: {
    resetList: 'resetList',
    setColumns: 'setColumns',
    setColumnVisibility: 'setColumnVisibility',
    setFilters: 'setFilters',
    fetchSubMerchantsFiltersSuccess: 'fetchSubMerchantsFiltersSuccess',
    fetchSubMerchantsData: 'fetchSubMerchantsData',
    fetchSubMerchantsDataSuccess: 'fetchSubMerchantsDataSuccess',
    fetchSubMerchantsDetails: 'fetchSubMerchantsDetails',
    fetchSubMerchantsDetailsSuccess: 'fetchSubMerchantsDetailsSuccess',
    fetchSubMerchantsNextReleaseSuccess: 'fetchSubMerchantsNextReleaseSuccess',
    fetchSubMerchantsNextRelease: 'fetchSubMerchantsNextRelease',
    fetchCountriesSuccess: 'fetchCountriesSuccess',
    fetchPspMerchantsData: 'fetchPspMerchantsData',
    fetchPspMerchantsDataSuccess: 'fetchPspMerchantsDataSuccess',
    clearSubMerchantsList: 'clearSubMerchantsList',
    clearSubMerchantsDetails: 'clearSubMerchantsDetails'
  },
};

export default namespace('SubMerchants', types);
